module.exports = __webpack_public_path__ + "img/stock-4.b675ce48.jpg";